import { Button, Form, Modal, Notification } from "@cea/ui-kit";
import PropTypes from "prop-types";
import { useContext, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import FileUploadContext from "../../../contexts/FileUploadContext";
import OrganizationContext from "../../../contexts/OrganizationContext";
import { getNotification } from "../../../utils";
import { createQAFiles } from "../../../utils/createFiles";
import getServiceLineName from "../utils/getServiceName";

import ReportUploadForm from "./components/ReportUploadForm";

const QAReportUploadModal = ({
  isVisible,
  handleCancel,
  summaryReport,
  clientId,
  clientReport,
  parentId: parentFolderId,
  shouldAllowZip,
  handleOk,
}) => {
  const [form] = Form.useForm();
  const [query] = useSearchParams();
  const { serviceLine, projectId } = useParams();

  const { service, organization, serviceMeta } =
    useContext(OrganizationContext);
  const { showUploadProgressNotification } = useContext(FileUploadContext);

  const resetForm = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (isVisible) {
      resetForm();
    }
  }, [isVisible]);

  const onFormSubmit = async () => {
    try {
      const folderId = query.get("folderId");
      const formValues = {
        ...form.getFieldsValue(),
        ...(summaryReport
          ? { serviceLine: getServiceLineName(serviceLine) }
          : {}),
      };

      showUploadProgressNotification({
        serviceType: service.serviceType,
        formValues,
        parentId: parentFolderId || folderId,
        clientId,
        createFiles: createQAFiles,
        metadata: {
          organizationId: organization.id,
          projectId: +projectId,
          summaryReport,
          clientReport,
          isPV_Project: serviceMeta.isPV_Project,
        },
        onFileCreate: handleOk,
      });

      form.resetFields();

      Notification.success({ message: "File Upload in Progress" });
      handleCancel();
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });
    }
  };

  return (
    <>
      <Modal
        title="Upload Report"
        visible={isVisible}
        onOk={onFormSubmit}
        onCancel={() => {
          handleCancel();
        }}
        centered
        width={720}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={async () => {
              const isFormValid = await form.validateFields();

              if (isFormValid) {
                onFormSubmit();
              }
            }}
            className="ml-auto"
          >
            Save
          </Button>,
        ]}
      >
        <ReportUploadForm formInstance={form} shouldAllowZip={shouldAllowZip} />
      </Modal>
    </>
  );
};

QAReportUploadModal.defaultProps = {
  isVisible: false,
  handleOk: () => {},
  summaryReport: false,
  clientReport: false,
  clientId: null,
  handleCancel: () => {},
  projectId: null,
  parentId: null,
  onFolderCreate: () => {},
  shouldAllowZip: false,
};

QAReportUploadModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  summaryReport: PropTypes.bool.isRequired,
  clientReport: PropTypes.bool,
  clientId: PropTypes.string,
  projectId: PropTypes.string,
  parentId: PropTypes.string,
  onFolderCreate: PropTypes.func,
  shouldAllowZip: PropTypes.bool,
};

export default QAReportUploadModal;
